import React from 'react';
import './Day1.css';
import Footer from '../Footer/Footer';

function Day2() {
  return (
    <div className='day1'>
      <div className='prog_header'>
        <h1 className='prog_header_kippra'>6TH KIPPRA ANNUAL REGIONAL CONFERENCE</h1>
        <h1 className='prog_header_theme'>THEME: ACCELERATING ECONOMIC GROWTH AND DEVELOPMENT FOR ASALS IN </h1>
        <h1 className='prog_header_theme'>KENYA</h1>
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th style={{fontWeight:'600', textDecoration:'underline'}} colSpan="2" >DAY 2: 22nd JUNE  2023</th>
             
            </tr>
          
          </thead>
          <tbody>
            <tr>
              <td style={{fontWeight:"bold"}}>7:00 - 8:00</td>
              <td>KIPPRA DOCUMENTARY</td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>8.00 - 8.10</td>
              <td>PRAYERS</td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>8.10 – 8.20</td>
              <td>RECAP OF DAY ONE: Key highlights</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{fontWeight:'600'}} colSpan="2" >THEME 3: HUMAN CAPITAL DEVELOPMENT IN ASALS</th>
             
            </tr>
             </thead>
             <thead>
            <tr>
              <th style={{fontWeight:'bold', backgroundColor: "white", color: "black"}} colSpan="2" >PLENARY SESSION 3.1 – HUMAN CAPITAL DEVELOPMENT IN ASALS </th>
             
            </tr>
          
          </thead>
          <tbody>
            <tr>
              <td style={{fontWeight:"bold"}}>8.30 – 9.30</td>
              <td style={{fontWeight:"normal"}}>
              Education and Skills Development in ASALs<br /> <br />
              Population Dynamics and Migration  <br /> <br />
              Poverty, Health and Nutrition Dynamics <br /> <br />

                                             </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>9.30 - 10.00</td>
              <td style={{fontWeight:"bold"}}>INTERLUDE AND REFRESHMENT BREAK</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{fontWeight:'bold', backgroundColor: "white", color: "black"}} colSpan="2" >SPECIAL SESSION 1 – OFFICIAL OPENING OF THE CONFERENCE</th>
             
            </tr>
          
          </thead>
          <tbody>
          <tr>
              <td style={{fontWeight:"bold"}}>10.20-11.30</td>
              <td style={{fontWeight:"normal", fontStyle: 'normal'}}><span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_1:&nbsp; </span> <div /> Recap of Conference Agenda - KIPPRA <br />Entertainment <br /><br />
              <span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_2:&nbsp; </span> Welcoming Remarks: Executive Director- KIPPRA <br /> <br />
              <span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_3:&nbsp; </span> Opening Remarks:  Chairperson-KIPPRA Board <br /> <br />
               <span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_4:&nbsp; </span> Remarks: Kilifi County Governor <br /><br /> Speech: Chair, CoG Committee on ASALS <br /><br /> Speech: PS, State Department for ASALS <br /><br />
               <span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_5:&nbsp; </span>Speech: PS, State Department for Economic Planning <br /><br />
               <span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_6:&nbsp; </span> Speech: CS, Ministry of East Africa Community, ASALs and Regional <br /> Development <br /> <br />
               <span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_7:&nbsp; </span> Speech: CS, Ministry of Public Service and Gender <br /> <br />
               <span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_8:&nbsp; </span> Speech: CS, National Treasury and Economic Planning <br /><br />
               <span style={{fontStyle: "italic", fontWeight: "bold"}}>SS1_9:&nbsp; </span> Keynote Address and Official Opening: H.E Deputy President , Hon. <br /> Rigathi Gachagua   </td>
            </tr>
            
          </tbody>
          <thead>
            <tr>
              <th style={{fontWeight:'600'}} colSpan="2" >THEME 4: GOVERNANCE, PEACE AND SECURITY</th>
             
            </tr>
          
          </thead>

          <thead>
            <tr>
              <th style={{fontWeight:'bold', backgroundColor: "white", color: "black"}} colSpan="2" >PLENARY SESSION 4.1:   Governance, Peace and Security in ASALs  </th>
             
            </tr>
          
          </thead>

          <tbody>
            <tr>
              <td style={{fontWeight:"bold"}}>11.00 – 12.30</td>
              <td style={{fontWeight:"normal"}}>Devolution and Economic Growth in ASAL Counties <br /> <br />
                                            

                                             </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>12.30 - 13.30</td>
              <td style={{fontWeight:"bold"}}>LUNCH BREAK</td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>13.30 – 14.40</td>
              <td style={{fontWeight:"normal"}}>Political Leadership and Development in ASAL Counties <br /> <br />
                                                  Refugees Economy and the host economy<br /> <br />
                                                  Peace Building Initiatives for accelerated development. <br /> <br />
                                                <span style={{fontStyle: "italic"}}>A short clip on the subject</span>  

                                            

                                             </td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{fontWeight:'600'}} colSpan="2" >THEME 5: CREATIVE ECONOMY AND TOURISM </th>
             
            </tr>
          
          </thead>

          <thead>
            <tr>
              <th style={{fontWeight:'bold', backgroundColor: "white", color: "black"}} colSpan="2" >PLENARY SESSION 5.1 Creative Economy and Tourism in ASALs	                                                                                                        </th>
             
            </tr>
          
          </thead>

          <tbody>
            <tr>
              <td style={{fontWeight:"bold"}}>14.40-15.45</td>
              <td style={{fontWeight:"normal"}}>Promoting Tourism in ASALs   <br /> <br />
              Commercializing Sporting Activities and Performing Arts in ASALs <br /> 
              Exploiting opportunities in Culture, Heritage, Archaeological Sites and  <br />
              Museums for Economic Growth  <br />
                                            

                                             </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>15.45 – 16.30</td>
              <td style={{fontWeight:"normal"}}>Chairs of Parallel sessions to make presentations</td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>16.30 – 16.45</td>
              <td style={{fontWeight:"bold"}}>REFRESHMENT AND ENTERTAINMENT </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>19:00 - 21:00</td>
              <td style={{fontWeight:"bold"}}>KILIFI Governor’s Dinner </td>
            </tr>
          </tbody>
         

        
          
        </table>
      </div>
      <div style={{marginTop: "20px"}}>
        <Footer />
      </div>
    </div>
  )
}

export default Day2;
